

































































// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import {
  SortDirectionMap,
  AbstractTableProps,
  tableProps,
  useTable
} from '../../../../../abstract/components/Table'

import { DashmixTheme } from '../../../contracts'

import { DashmixCheck } from '../../atoms/Check'
import { DashmixIcon, DashmixIconName } from '../../atoms/Icon'

import { DashmixFakeRow } from './_partials/FakeRow.vue'
import { DashmixTableCell } from './_partials/TableCell'
import { DashmixTableRow } from './_partials/TableRow.vue'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const DashmixTable = defineComponent({
  name: 'DashmixTable',
  components: {
    DashmixCheck,
    DashmixFakeRow,
    DashmixIcon,
    DashmixTableCell,
    DashmixTableRow
  },
  props: tableProps,
  emits: ['do', 'selected', 'sortBy'],

  setup (props: AbstractTableProps, ctx: SetupContext) {
    return {
      ...useTable(props, ctx),
      DashmixIconName,
      direction: SortDirectionMap
    }
  }
})

export default DashmixTable
